export function printPdf(
  doc: any,
  options?: { closeAfterPrint?: boolean },
): Promise<void> {
  return new Promise((resolve) => {
    const { closeAfterPrint = true } = options || {};

    if (typeof doc.autoPrint === "function") {
      doc.autoPrint();
    }

    const blobUrl: string = doc.output("bloburl");

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.style.display = "none";

    iframe.src = blobUrl;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } catch (err) {
        console.warn("Print error:", err);
      }

      // 🔥 Only safe cleanup method
    //   setTimeout(() => {
    //     if (closeAfterPrint && document.body.contains(iframe)) {
    //       document.body.removeChild(iframe);
    //       URL.revokeObjectURL(blobUrl);
    //     }
    //     resolve();
    //   }, 2000); // Slightly longer for thermal
    };
  });
}
